import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import { createElement } from 'react';

import { gridLayoutContainer } from '../../../styleUtility/gridLayout';
import RouterLink from '../../primitive/RouterLink';
import { Props as ItemProps } from './Item';

type Props = ItemProps & {
  index: number;
  lastIndex: number;
};

type StyledComponentProps = {
  noArrow: boolean;
  noShrink: boolean;
  reverseIndex: number;
};

const ItemImpl = ({ href, index, lastIndex, children }: Props) => {
  const isFirst = index === 0;
  const isLast = index === lastIndex;
  const noArrow = (isLast && !isFirst) || lastIndex === 0;

  const label = href ? (
    <AnchorLabel href={href} variant="body2" align="right" noWrap>
      {children}
    </AnchorLabel>
  ) : (
    <Label variant="body2" color="textSecondary" align="right" noWrap>
      {children}
    </Label>
  );

  const arrow = noArrow ? null : <Arrow color="disabled" />;

  return (
    <Root noArrow={noArrow} noShrink={isFirst} reverseIndex={lastIndex - index + 1}>
      {label}

      {arrow}
    </Root>
  );
};

const Root = styled('div')<StyledComponentProps>(({ noArrow, noShrink, reverseIndex }) => ({
  ...gridLayoutContainer({
    columns: noArrow ? ['1fr'] : ['1fr', '40px'],
    rows: ['auto'],
    areas: noArrow ? [['body']] : [['arrow', 'body']],
    alignItems: 'center',
    justifyItems: 'flex-start',
  }),
  minHeight: 24,
  flexShrink: noShrink ? 0 : reverseIndex,
}));

const labelStyle = { maxWidth: '100%' };

const Label = styled(Typography)(labelStyle);

const AnchorLabel = styled(RouterLink)(labelStyle);

const Arrow = styled(ChevronRight)({
  width: 24,
  height: 24,
  justifySelf: 'center',
});

export default ItemImpl;
